import {
  TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA,
  TICKET_DASHBOARD_METRICS_TEAM_GET_DATA,
  TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA,
} from "./Constants";

// Individual
const loadTicketDashboardIndividualRequest = (request) => ({
  type: TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA.TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_LOAD,
  request,
});
const setTicketDashboardIndividualSuccess = (individualMetrics) => ({
  type: TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA.TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_SUCCESS,
  individualMetrics,
});
const setTicketDashboardIndividualFail = (error) => ({
  type: TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA.TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_FAIL,
  error,
});

// Team
const loadTicketDashboardTeamRequest = (request) => ({
  type: TICKET_DASHBOARD_METRICS_TEAM_GET_DATA.TICKET_DASHBOARD_METRICS_TEAM_GET_LOAD,
  request,
});
const setTicketDashboardTeamSuccess = (teamMetrics) => ({
  type: TICKET_DASHBOARD_METRICS_TEAM_GET_DATA.TICKET_DASHBOARD_METRICS_TEAM_GET_SUCCESS,
  teamMetrics,
});
const setTicketDashboardTeamFail = (error) => ({
  type: TICKET_DASHBOARD_METRICS_TEAM_GET_DATA.TICKET_DASHBOARD_METRICS_TEAM_GET_FAIL,
  error,
});

// Organization
const loadTicketDashboardOrganizationRequest = (request) => ({
  type: TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA.TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_LOAD,
  request,
});
const setTicketDashboardOrganizationSuccess = (organizationMetrics) => ({
  type: TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA.TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_SUCCESS,
  organizationMetrics,
});
const setTicketDashboardOrganizationFail = (error) => ({
  type: TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA.TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_FAIL,
  error,
});

export {
  loadTicketDashboardIndividualRequest, setTicketDashboardIndividualSuccess, setTicketDashboardIndividualFail,
  loadTicketDashboardTeamRequest, setTicketDashboardTeamSuccess, setTicketDashboardTeamFail,
  loadTicketDashboardOrganizationRequest, setTicketDashboardOrganizationSuccess, setTicketDashboardOrganizationFail,
};